import { motion } from "motion/react";
import { cn } from "../../lib/utils";

interface LogoProps {
  letter: string;
  opacity: number;
  animated?: boolean;
}

type BetaBidgeSize = "normal" | "small";

export default function Logo({
  className,
  betaBidgeSize = "normal",
  animated = true,
}: {
  className?: string;
  betaBidgeSize?: BetaBidgeSize;
  animated?: boolean;
}) {
  const projectNameArray = () => {
    const arr: LogoProps[] = [
      {
        letter: "K",
        opacity: 1,
      },
      {
        letter: "o",
        opacity: 0.9,
      },
      {
        letter: "n",
        opacity: 0.8,
      },
      {
        letter: "t",
        opacity: 0.7,
      },
      {
        letter: "r",
        opacity: 0.6,
      },
      {
        letter: "o",
        opacity: 0.5,
      },
      {
        letter: "l",
        opacity: 0.4,
      },
    ];

    return arr;
  };

  return (
    <div
      className={cn(
        "text-4xl font-extrabold text-accent flex items-center",
        className
      )}
    >
      {projectNameArray().map((letter, index) => (
        <motion.div
          key={index}
          initial={animated ? { opacity: 0 } : undefined}
          animate={animated ? { opacity: [0, 0.5, 1] } : { opacity: 1 }}
          transition={
            animated
              ? {
                  duration: 2,
                  delay: index * 0.1,
                }
              : undefined
          }
        >
          {letter.letter}
        </motion.div>
      ))}

      <motion.div
        className={cn(
          "text-sm text-dark bg-primary px-2 py-0.5 ml-2 rounded-md",
          betaBidgeSize === "small" && "text-xs"
        )}
        initial={animated ? { opacity: 0 } : undefined}
        animate={animated ? { opacity: [0, 0.5, 1] } : { opacity: 1 }}
        transition={
          animated
            ? {
                duration: 0.5,
                delay: 1,
              }
            : undefined
        }
      >
        BETA
      </motion.div>
    </div>
  );
}
